import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initialState";
import { CREATE_FULL_SCREEN_SELECTOR } from "../constants";

// const simpleSetPayload = (stateField) => (state, action) => { state[stateField] = action.payload; };

export const fullScreenSlice = createSlice({
  name: "vocabulary",
  initialState,
  reducers: {
    setFullScreenComponentType: (state, action) => {
      state.fullScreenComponentType = action.payload;
    },
  },
});

export const {
  setFullScreenComponentType,
} = fullScreenSlice.actions;

//selectors
const simpleFieldSelector = (stateField) => CREATE_FULL_SCREEN_SELECTOR(state => state[stateField]);

const selectFullScreenComponentType = simpleFieldSelector("fullScreenComponentType");
const selectIsFullScreen = CREATE_FULL_SCREEN_SELECTOR(s => !!s.fullScreenComponentType);

export {
  selectFullScreenComponentType,
  selectIsFullScreen,
};

export default fullScreenSlice.reducer;
